import { render, staticRenderFns } from "./MailingFields.vue?vue&type=template&id=4a0b0a20&scoped=true"
import script from "./MailingFields.vue?vue&type=script&lang=js"
export * from "./MailingFields.vue?vue&type=script&lang=js"
import style0 from "./MailingFields.vue?vue&type=style&index=0&id=4a0b0a20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0b0a20",
  null
  
)

export default component.exports